import { jsx as _jsx } from "react/jsx-runtime";
import { TimeInput as HeroTimeInput } from '@heroui/react';
export const TimeInput = (props) => {
    return _jsx(HeroTimeInput, { ...props });
};
export default TimeInput;
//# sourceMappingURL=TimeInput.js.map